import axios from 'axios'

import message from '../components/SessionExpiration'
import { SERVER_API_URL } from '../Global'
import Notifications from "../helpers/Notifications"

axios.defaults.baseURL =
	process.env.NODE_ENV === 'development'
		? `${SERVER_API_URL}/api`
		: `${window.location.origin}/api`
axios.defaults.headers['Pragma'] = 'no-cache'
axios.defaults.headers['Cache-Control'] = 'no-cache, no-store'
axios.interceptors.request.use((config) => {
	const language = window.localStorage.getItem('language')
	if (language)
		config.headers['Accept-Language'] = language
	return config
}, (error) => {
	return Promise.reject(error)
})

axios.interceptors.request.use((config) => {
	const jsonUser = window.localStorage.getItem('user')
	if (jsonUser) {
		const user = JSON.parse(jsonUser)
		config.headers.Authorization = `Bearer ${user.token}`
	}
	return config
}, (error) => {
	return Promise.reject(error)
})

axios.interceptors.response.use(undefined, (error) => {
	const originalRequest = error.config
	const resp = error.response
	if (resp.status === 401 && !originalRequest._retry) {
		originalRequest._retry = true
		const jsonUser = window.localStorage.getItem('user')
		const idToken = window.localStorage.getItem("idToken")
		if (jsonUser) {
			const user = JSON.parse(jsonUser)
			return axios
				.post('/account/refresh', {
					refreshToken: user.refreshToken,
					token: user.token
				})
				.then((res) => {
					if (res.status === 200) {
						window.localStorage.setItem('user', JSON.stringify({
							userName: res.data.userName,
							token: res.data.token,
							refreshToken: res.data.refreshToken
						}))
						if (originalRequest.url.includes('user/logout')) {
							return User.logout({
								idToken: idToken
							})
						}
						return axios(originalRequest)
					}
					return Promise.reject(error.response)
				})
				.catch((err) => {
					return Promise.reject(err)
				})
		}
		else if (!originalRequest.url.includes('refreshUserData'))
			message()
	} else if (resp.status == 400 && resp.data.message == 'Invalid refresh token') {
		const jsonUser = window.localStorage.getItem('user')
		if (jsonUser)
			message()
	} else {
		// let title = undefined
		// let message = undefined
		// if (resp.status === 404 && !resp.data?.message) {
		// 	title = '404 Not Found'
		// } else if (resp.data?.message) {
		// 	message = resp.data.message
		// 	if (resp.data.message.length < 100) {
		// 		title = resp.data.code
		// 	}
		// }
		// if (title || message)
		// 	Notifications.errorNotice(title, message, 10)
		handleError(resp)
		return Promise.reject(resp);
	}
})

function handleError(response) {
	if ((response.data instanceof ArrayBuffer && response.data.byteLength !== undefined) || (response.data instanceof Blob && response.data.size !== undefined)) {
		const reader = new FileReader()
		reader.onloadend = function () {
			const err = JSON.parse(reader.result)
			const code = err?.code ?? ""
			const description = (err?.errors instanceof Array ? err.errors.map(e => e.message).join(", ") : err?.message) ?? ""
			Notifications.errorNotice(code, description)
		}
		reader.readAsText(new Blob([response.data], { type: 'text/plain' }))
	}
	else {
		const code = response.data.code ?? ""
		const description = (response.data.errors instanceof Array ? response.data.errors.map(e => e.message).join(", ") : response.data.message) ?? ""
		Notifications.errorNotice(code, description)
	}
}

const responseBody = (response) => response.data
export const requests = {
	getFile: (url, query = {}) => axios
		.get(url, {
			responseType: 'blob',
			params: query
		})
		.then(responseBody),
	getLargeFile: (url, query = {}) => axios
		.get(url, {
			responseType: 'arraybuffer',
			params: query
		})
		.then(responseBody),
	get: (url) => axios.get(url).then(responseBody),
	getWithParams: (url, query = {}) => axios
		.get(url, {
			params: query
		})
		.then(responseBody),
	post: (url, body = {}) => axios.post(url, body).then(responseBody),
	postFile: (url, body = {}) => axios.post(url, body, {
		responseType: 'blob'
	}).then(responseBody),
	postFileMultiPart: (url, body = {}) => axios.post(url, body, {
		headers: {
			"Content-Type": "multipart/form-data",
		}
	}).then(responseBody),
	put: (url, body = {}) => axios.put(url, body).then(responseBody),
	del: (url, query = {}) => axios
		.delete(url, {
			data: query
		})
		.then(responseBody),
	postForm: (url, file) => {
		const formData = new FormData()
		formData.append('File', file)
		return axios
			.post(url, formData, {
				headers: {
					'Content-type': 'multipart/form-data'
				}
			})
			.then(responseBody)
	},
	postFormMany: (url, files) => {
		const fd = new FormData()
		files.forEach((file) => {
			fd.append('Files', file)
		})
		return axios
			.post(url, fd, {
				headers: {
					'Content-type': 'multipart/form-data'
				}
			})
			.then(responseBody)
	}
}

const User = {
	login: (user) => requests.post('/account/login', user),
	logout: (data) => requests.post('/account/logout', data),
	refreshUserData: data => requests.post('/account/refreshUserData', data)
}

export default {
	User,
	requests
}
